import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import './style.scss';

const Avatar = (props) => {
  const {
    photo = null,
    text = null,
    icon = null,
    size,
    borderSize,
    className,
    showTooltip,
    hideTooltip,
    updateTooltip,
    tooltipElement } = props;

  // Size to be an even value to ensure circles aren't off center.
  const elementSize = size % 2 === 0 ? `${size}px` : `${size + 1}px`;
  const borderRadius = `${Math.ceil(size / 2)}px`;

  const innerSizeInt = size - 2 * borderSize;
  const innerSize = `${innerSizeInt}px`;
  const innerRadius = `${Math.ceil(innerSizeInt / 2)}px`;

  const styleAttrs = {
    width: elementSize,
    height: elementSize,
    borderRadius,
    fontSize: elementSize,
    overflow: tooltipElement ? 'visible' : 'hidden',
  };

  const imgStyle = {
    maxWidth: innerSize,
    maxHeight: innerSize,
    borderRadius: innerRadius,
    objectFit: 'cover',
    backgroundColor: '#fff',
  };

  const circleTextStyle = {
    ...imgStyle,
    lineHeight: innerSize,
    backgroundColor: undefined,
  };

  const tooltipProps = {};

  if (tooltipElement) {
    tooltipProps.onMouseEnter = event => {
        showTooltip();
        updateTooltip(event);
    };
    tooltipProps.onMouseMove = event => updateTooltip(event);
    tooltipProps.onMouseLeave = hideTooltip;
  }

  return (
    <>
      <div
        className={clsx('avatar', className)}
        style={styleAttrs}
        {...tooltipProps}
      >
        {photo && (
          <img src={photo}
            style={imgStyle}
            alt=""
          />
        )}
        {(text || icon) && (
          <div
            className={clsx('avatar__text', size > 150 && 'large', size < 85 && 'small')}
            style={circleTextStyle}
          >
            {text || icon}
          </div>
        )}
        {tooltipElement}
      </div>
    </>
  );
};

Avatar.propTypes = {
  photo: PropTypes.string,
  text: PropTypes.string,
  icon: PropTypes.element,
  size: PropTypes.number.isRequired,
  borderSize: PropTypes.number.isRequired,
  className: PropTypes.string,
  showTooltip: PropTypes.func,
  hideTooltip: PropTypes.func,
  updateTooltip: PropTypes.func,
  tooltipElement: PropTypes.func,
};

export default Avatar;
